<template>
    <HeaderList>
        <template #content>
            <h1 class="name">{{ $t('views.partner_users.title') }}</h1>
            <p>{{ $t('views.partner_users.description') }}</p>
        </template>
        <template #actions v-if="userStore.isPartnerGod || (userStore.isPartnerAdmin && userStore.partnerRole > 0 && userStore.partnerRole < 10)">
            <PartnerUserCreate />
        </template>
    </HeaderList>
</template>

<script>
import HeaderList from '@/components/sections/HeaderList';
import PartnerUserCreate from '@/components/admin/partnerAdmins/PartnerUserCreate';
import { useUserStore } from '@/stores/user';

export default {
    name: "PartnerUserHeader",
    components: {
        HeaderList,
        PartnerUserCreate
    },
    computed: {
        userStore() {
            return useUserStore();
        }
    }
}
</script>
